<script setup lang="ts">
import {trustpilotUrl} from "@/constants.js";
</script>

<template>
    <a class="px-10 shadow-[inset_2px_-2px_4px_0_rgba(0,0,0,0.3)] py-4 bg-green-100 w-full items-center shadow-[0_2px_6px_0_rgba(0,0,0,0.06)] flex justify-center gap-5 rounded-lg" target="_blank" :href="trustpilotUrl">
        <p class="text-lg font-medium font-['Unbounded'] text-black">
            {{$t('Review us on')}}:
        </p>
        <div class="flex items-center gap-5">
            <img src="/assets/img/roblox/trustpilot-logo.webp" style="width: 80px; height: 37px" alt="trustpilot-logo">
            <p class="text-2xl font-medium font-['Unbounded'] text-black">
                4.8
            </p>
        </div>
    </a>
</template>
